import http from '../http-common'

class ComuniDataService {
  getComuni () {
    return http.get('comuni')
  }

  getComuneById (codice) {
    return http.get(`comune/${codice}`)
  }

  getComuneByNome (nome) {
    return http.get(`comune/${nome}`)
  }

  insert (data) {
    return http.post('comune', data)
  }

  update (id, data) {
    return http.put(`comune/${id}`, data)
  }

  delete (id) {
    return http.delete(`comuni/${id}`)
  }

  findByNome (nome) {
    return http.get(`comuni?nome=${nome}`)
  }
}

export default new ComuniDataService()
